import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fieldsFrame", "serviceId", "date", "amountPer", "count", "total"];

  serviceIdTarget;
  dateTarget;
  fieldsFrameTarget;

  amountPerTarget;
  hasCountTarget;
  countTarget;
  hasTotalTarget;
  totalTarget;

  isUpdating = false;

  connect() {
    this.calculate();

    const observer = new MutationObserver((_mutations) => {
      if (!this.isUpdating) {
        this.calculate();
      }
    });

    observer.observe(this.fieldsFrameTarget, {
      childList: true,
      subtree: false
    });
  }

  updateFields(_event) {
    const serviceId = this.serviceIdTarget.value;
    const date = this.dateTarget.value;

    if (!serviceId || !date) {
      console.error("Missing required inputs:", { serviceId, date });
      return;
    }

    console.log("Updating fields for service:", serviceId, "date:", date);

    this.isUpdating = true;

    this.fieldsFrameTarget.innerHTML = '<div class="text-center"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...</div>';

    fetch(`/charges/update_fee_fields?service_id=${serviceId}&date=${date}`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/html, application/xhtml+xml"
      }
    })
    .then(response => {
      if (response.ok) {
        return response.text();
      }
      throw new Error(`Network response was not ok: ${response.status}`);
    })
    .then(html => {
      if (html.trim().startsWith("<turbo-stream")) {
        // Handle turbo-stream response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const template = doc.querySelector("turbo-stream template");

        if (template) {
          const templateContent = template.innerHTML;
          console.log("Template content preview:", templateContent.substring(0, 100) + "...");
          this.fieldsFrameTarget.innerHTML = templateContent;
        } else {
          console.error("No template found in turbo-stream");
          this.fieldsFrameTarget.innerHTML = '<div class="alert alert-warning">Missing template content</div>';
        }
      } else {
        this.fieldsFrameTarget.innerHTML = html;
      }

      this.reattachEventListeners();

      this.calculate();
      this.isUpdating = false;
    })
    .catch(error => {
      console.error("Error fetching fee fields:", error);
      this.fieldsFrameTarget.innerHTML = '<div class="alert alert-danger">Failed to update fields: ' + error.message + '</div>';
      this.isUpdating = false;
    });
  }

  reattachEventListeners() {
  }

  calculate() {
    if (!this.hasTotalTarget) {
      return;
    }

    const amountPer = parseFloat(this.amountPerTarget.value) || 0;
    const count = this.hasCountTarget ? parseFloat(this.countTarget.value) || 0 : 1;
    const value = amountPer * count;

    if (this.totalTarget.textContent !== value.toFixed(2)) {
      this.totalTarget.textContent = value.toFixed(2);
    }
  }
}
